import {Component, OnInit, EventEmitter} from '@angular/core';
import {Router} from '@angular/router';

import {DipRegistrationExpirationModalComponent} from './modals/dip-registration-expiration-modal/dip-registration-expiration-modal.component';
import {TranslateService} from '@ngx-translate/core';
import {DipRegistrationNavigationService} from './core/services/dip-registration-navigation.service';
import {DipRegistrationService} from './dip-registration.service';
import {DipRegistrationContextService} from './core/services/dip-registration-context.service';
import { IdleService } from './shared/services/idle.service';
import { ModalService } from './shared/components/modal/modal.service';

@Component({
    selector: 'dip-registration-root',
    templateUrl: './dip-registration.component.html',
    styleUrls: ['./dip-registration.component.scss'],
    standalone: false
})
export class DipRegistrationComponent implements OnInit {

  constructor(
    private router: Router,
    private dipseModalService: ModalService,
    private dipRegistrationIdleService: IdleService,
    private translateService: TranslateService,
    private dipRegistrationService: DipRegistrationService,
    private dipRegistrationContextService: DipRegistrationContextService,
    private dipRegistrationNavigationService: DipRegistrationNavigationService
  ) {
  }

  async ngOnInit() {
    // subscribe to router to set the page title and setup BioCatch and apply tagging
    await this.dipRegistrationNavigationService.init();

    this.dipRegistrationIdleService.onTimeout.subscribe(async () => {
      if (!this.router.url.includes('overview')) {
        const [modalPromise, modalDestroy] = await this.showTimeoutWarningModal();

        // set timout to go to kill session if user is not doing anything
        const timer = setTimeout(async () => {
          modalDestroy.emit(true);
          // we will call delete context to make sure session is deleted.
          await this.dipRegistrationService.killSession();
          this.router.navigate(['session-expired'], this.dipRegistrationContextService.buildParams());
        }, this.dipRegistrationContextService.getRemainingSessionTimeout());

        // if use clicked on resume button or close button in modal, restart timeout
        modalPromise.then(timeout => {
          if (!timeout) {
            clearTimeout(timer);
            this.dipRegistrationIdleService.start(this.dipRegistrationContextService.getSessionWarningTimeout());
          }
        });
      } else {
        this.dipRegistrationNavigationService.setSessionExpiredFlag();
      }
    });

  }

  isLoaded() {
    return this.dipRegistrationContextService.isContextLoaded();
  }

  async showTimeoutWarningModal(): Promise<[Promise<boolean>, EventEmitter<boolean>]> {
    let destroy: EventEmitter<boolean | undefined>;
    const title = await this.translateService.get('DIPRSRegistration.expiration.modal.title').toPromise();
    const promise = this.dipseModalService.create<DipRegistrationExpirationModalComponent, boolean>(
      DipRegistrationExpirationModalComponent,
      (containerInstance, instance) => {
        destroy = containerInstance.destroy;
        containerInstance.modalTitle = title;
        containerInstance.modalDialogClass = 'modal-md';
        containerInstance.closeLabel = this.translateService.instant('DIPRSRegistration.modal.close.label');
        instance.close.subscribe(() => containerInstance.destroy.emit());
        instance.limit = Date.now() + this.dipRegistrationContextService.getRemainingSessionTimeout();
      },
      null
    ).toPromise();
    return [promise, destroy];
  }
}
